import React from "react";
import {
  faCircleChevronDown,
  faCircleChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const expanded = () => {
  return {
    // Build our expander column
    id: "expander", // Make sure it has an ID
    Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
      <span {...getToggleAllRowsExpandedProps()}>
        {isAllRowsExpanded ? (
          <FontAwesomeIcon
            icon={faCircleChevronRight}
            size="xl"
            style={{ color: "#2b506d" }}
          />
        ) : (
          <FontAwesomeIcon
            icon={faCircleChevronDown}
            size="xl"
            style={{ color: "#2b506d" }}
          />
        )}
      </span>
    ),
    Cell: ({ row }) => (
      <span {...row.getToggleRowExpandedProps()}>
        {row.isExpanded ? (
          <FontAwesomeIcon
            icon={faCircleChevronRight}
            size="xl"
            style={{ color: "#f2ce00" }}
          />
        ) : (
          <FontAwesomeIcon
            icon={faCircleChevronDown}
            size="xl"
            style={{ color: "#f2ce00" }}
          />
        )}
      </span>
    ),
  };
};
